import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import React from 'react';
import { Box } from '@applyboard/ui-components';
import { Card, Flex, Text, Button } from '@applyboard/crystal-ui';
import personalDevelopmentImg from "./personalDevelopment.png";
import { useEventTracker } from '@applyboard/ui-utils';
var LoginButton = function LoginButton(_ref) {
  var program = _ref.program;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  return /*#__PURE__*/React.createElement(Button, {
    emphasis: "outlined",
    intent: "primary",
    onClick: function onClick() {
      trackEvent({
        event: 'Programs Page - Login to Explore More card clicked',
        data: {
          programId: program === null || program === void 0 ? void 0 : program.id,
          programName: program === null || program === void 0 ? void 0 : program.name
        }
      });
      var redirectToUrl = "".concat(location.href).concat(location.href.indexOf('?') !== -1 ? '&' : '?', "_source=login");
      window.location.href = "/login?redirect_to=".concat(encodeURIComponent(redirectToUrl));
    }
  }, "Login Now");
};
var CardText = function CardText(_ref2) {
  var center = _ref2.center;
  return /*#__PURE__*/React.createElement(Text, {
    contrast: "inverted",
    intent: "secondary",
    variant: "titleL",
    align: center ? 'center' : 'start'
  }, "Login Now & Experience More");
};
var CardImage = function CardImage() {
  return /*#__PURE__*/React.createElement("img", {
    src: personalDevelopmentImg,
    alt: "Apply Board Login",
    height: "56",
    width: "56"
  });
};
var HorizontalLoginCard = function HorizontalLoginCard(_ref3) {
  var program = _ref3.program;
  return /*#__PURE__*/React.createElement(Card, {
    "aria-label": "Login to access full program details",
    as: "section",
    emphasis: "outlined",
    gradient: "primary",
    gradientDirection: "horizontal-reverse"
  }, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement(Box, {
    px: 4
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "row",
    align: "center",
    justify: "between",
    gap: 8
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "row",
    align: "center",
    gap: 8
  }, /*#__PURE__*/React.createElement(CardImage, null), /*#__PURE__*/React.createElement(CardText, null)), /*#__PURE__*/React.createElement(LoginButton, {
    program: program
  })))));
};
var VerticalLoginCard = function VerticalLoginCard(_ref4) {
  var program = _ref4.program;
  return /*#__PURE__*/React.createElement(Card, {
    "aria-label": "Login to access full program details",
    as: "section",
    emphasis: "outlined",
    gradient: "primary",
    gradientDirection: "horizontal-reverse"
  }, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement(Box, {
    px: 8
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    align: "center",
    gap: 4
  }, /*#__PURE__*/React.createElement(CardImage, null), /*#__PURE__*/React.createElement(CardText, {
    center: true
  }), /*#__PURE__*/React.createElement(LoginButton, {
    program: program
  })))));
};
export var LoginCard = function LoginCard(_ref5) {
  var vertical = _ref5.vertical,
    program = _ref5.program;
  return vertical ? /*#__PURE__*/React.createElement(VerticalLoginCard, {
    program: program
  }) : /*#__PURE__*/React.createElement(HorizontalLoginCard, {
    program: program
  });
};